import firebase from 'firebase/compat/app';
import { useState, useEffect } from 'react';
import { v4 } from 'uuid';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var GetLogger = /** @class */ (function () {
    function GetLogger() {
        this.DEBUG = false;
    }
    GetLogger.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.DEBUG) {
            console.log.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    return GetLogger;
}());
var logger = new GetLogger();

var WebRoles = /** @class */ (function () {
    function WebRoles() {
        var _this = this;
        this.assignToCurrentUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, firebase.functions().httpsCallable("assignRolesToUser")()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.log("Error happen during assign roles to user: " + error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    return WebRoles;
}());

function useTimeout(delay) {
    return new Promise(function (resolve) { return setTimeout(resolve, delay); });
}

var noInputSideEffectListeners = {};

function sideEffectsAfterAuthReloaded(timeout) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logger.log("start side effect after loaded refresh token, length " + Object.keys(noInputSideEffectListeners).length);
                    return [4 /*yield*/, useTimeout(500)];
                case 1:
                    _a.sent();
                    Object.keys(noInputSideEffectListeners).forEach(function (key) {
                        logger.log("invoking listener for key '" + key + "'");
                        noInputSideEffectListeners[key]();
                    });
                    return [2 /*return*/];
            }
        });
    });
}

var UserProfile = /** @class */ (function () {
    function UserProfile() {
    }
    return UserProfile;
}());
function listenToUserClaim(handler) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            firebase.firestore().collection("userClaims").doc((_a = UserProfile.user) === null || _a === void 0 ? void 0 : _a.uid).onSnapshot(handler);
            return [2 /*return*/];
        });
    });
}
function onNewClaims(snapshot) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var data, token;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = snapshot.data();
                    logger.log("New claims doc\n", data);
                    if (!!!(data === null || data === void 0 ? void 0 : data._lastCommitted)) return [3 /*break*/, 4];
                    if (!(!UserProfile.lastCommitted ||
                        (!!UserProfile.lastCommitted && !data._lastCommitted.isEqual(UserProfile.lastCommitted)))) return [3 /*break*/, 3];
                    logger.log("Refreshing token");
                    return [4 /*yield*/, ((_a = UserProfile.user) === null || _a === void 0 ? void 0 : _a.getIdToken(true))];
                case 1:
                    token = _b.sent();
                    logger.log("Token: " + token);
                    logger.log("start side effect");
                    return [4 /*yield*/, sideEffectsAfterAuthReloaded()];
                case 2:
                    _b.sent();
                    logger.log("finished side effect");
                    _b.label = 3;
                case 3:
                    logger.log("setting global last committed timestamp");
                    UserProfile.lastCommitted = data._lastCommitted;
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function reportUserClaims() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var result, roles;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ((_a = UserProfile.user) === null || _a === void 0 ? void 0 : _a.getIdTokenResult(false))];
                case 1:
                    result = _b.sent();
                    roles = result === null || result === void 0 ? void 0 : result.claims.yardzenWebRoles;
                    logger.log("Custom claims say I am " + (!!(roles === null || roles === void 0 ? void 0 : roles.isAdmin) ? "" : "not ") + "an admin!");
                    logger.log("Custom claims say I am " + (!!(roles === null || roles === void 0 ? void 0 : roles.isAgent) ? "" : "not ") + "an agent!");
                    logger.log("Custom claims say I am " + (!!(roles === null || roles === void 0 ? void 0 : roles.isPurchased) ? "" : "not ") + "a customer!");
                    return [2 /*return*/];
            }
        });
    });
}
/* istanbul ignore next */
function InitUserClaimsListener(config) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            logger.DEBUG = !!(config === null || config === void 0 ? void 0 : config.isDebug);
            firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                    if (!!(config === null || config === void 0 ? void 0 : config.autoSetWebRoles)) {
                        logger.log("setting roles to user");
                        var webRoles = new WebRoles();
                        webRoles.assignToCurrentUser();
                    }
                    UserProfile.user = user;
                    listenToUserClaim(onNewClaims);
                    if (!!(config === null || config === void 0 ? void 0 : config.isDebug)) {
                        reportUserClaims();
                    }
                }
                else {
                    UserProfile.user = undefined;
                }
            });
            if (!!(config === null || config === void 0 ? void 0 : config.isDebug)) {
                firebase.auth().onIdTokenChanged(function () {
                    if (UserProfile.user) {
                        logger.log("new ID token for " + UserProfile.user.uid);
                        reportUserClaims();
                    }
                });
            }
            return [2 /*return*/];
        });
    });
}

function useAuthChange(useAuthChangeCallback, deps) {
    logger.log("register useAuthChange to current state");
    var _a = useState(-1), reloadTimestamp = _a[0], setReloadTimestamp = _a[1];
    var useEffectDeps = [reloadTimestamp];
    if (deps && deps.length > 0) {
        useEffectDeps = useEffectDeps.concat(deps);
    }
    useEffect(function () {
        var updateReloadTimestamp = function () {
            setReloadTimestamp(Date.now());
        };
        var uuid = v4();
        noInputSideEffectListeners[uuid] = updateReloadTimestamp;
        logger.log("invoke listener for key '" + uuid + "'");
        useAuthChangeCallback();
        return function () {
            delete noInputSideEffectListeners[uuid];
        };
    }, useEffectDeps);
}

var FirebaseComponents = /** @class */ (function () {
    function FirebaseComponents() {
        this.setUserClaimListener = InitUserClaimsListener;
    }
    FirebaseComponents.prototype.init = function (firebaseConfig) {
        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
        }
    };
    FirebaseComponents.prototype.setWebRolesForUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var webRoles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        webRoles = new WebRoles();
                        return [4 /*yield*/, webRoles.assignToCurrentUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return FirebaseComponents;
}());

var component = new FirebaseComponents();

export default component;
export { useAuthChange };
